<template>
  <b-card-text>
    <h5 class="my-2 font-weight-bold info-text">Dane uczestnika testu</h5>
    <b-row class="mb-3" v-if="!participateTimeQuestion">
      <b-col lg="12">
        <b-button
          class="btn-outline-white"
          variant="outline-light"
          @click="$emit('showCourse')"
        >
          <span
            class="font-weight-bold info-text"
            v-text="'< Powrót do Kursu'"
          ></span>
        </b-button>
      </b-col>
      <b-col lg="6" class="py-2 text-center">
        <b-button
          class="btn-outline-white"
          variant="outline-light"
          @click="onFirstTime"
        >
          <span class="font-weight-bold info-text"
            >PIERWSZY RAZ<br />
            bierzesz udział w teście?</span
          >
        </b-button>
      </b-col>

      <b-col
        lg="6"
        class="py-2 text-center"
        v-if="typeof participantNameOptions[0] !== 'undefined'"
      >
        <b-button
          class="btn-outline-white"
          variant="outline-light"
          @click="onAnotherTime"
        >
          <span class="font-weight-bold info-text"
            >POWTÓRNIE<br />
            przystępujesz do testu?</span
          >
        </b-button>
      </b-col>
    </b-row>

    <b-row class="mb-3" v-if="participateTimeQuestion">
      <b-col>
        <b-button
          class="btn-outline-white"
          variant="outline-light"
          @click="participateTimeQuestion = false"
        >
          <span class="font-weight-bold info-text" v-text="'< Powrót'"></span>
        </b-button>
      </b-col>
      <b-col
        lg="12"
        class="mr-1 py-2 text-center"
        v-if="participateTimeQuestion === 1"
      >
        Wpisz swoje dane:
        <b-row class="justify-content-md-center">
          <b-col lg="auto" class="mr-1 py-2">
            <b-form-input
              maxLength="50"
              class="wd-lg-400"
              v-model="participantName"
              placeholder="Imię i nazwisko"
            ></b-form-input>
          </b-col>

          <b-col lg="auto" class="mr-1 py-2">
            <b-button
              v-if="!loading"
              class="btn btn-accept-color text-white"
              variant="outline-success"
              @click="onAcceptName('input')"
              :disabled="participantName.length < 3"
            >
              Zatwierdź
            </b-button>
            <b-button
              v-else
              class="btn-accept-color"
              variant="outline-success"
              disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </b-col>

      <b-col
        lg="12"
        class="mr-1 py-2 text-center"
        v-if="participateTimeQuestion === 2"
      >
        Wybierz swoje dane z listy:
        <b-row class="justify-content-md-center">
          <b-col lg="auto" class="mr-1 py-2">
            <b-form-select
              class="wd-lg-400"
              v-model="participantNameSelect"
              :options="participantNameOptions"
              placeholder="Lista"
            ></b-form-select>
          </b-col>

          <b-col lg="auto" class="mr-1 py-2">
            <b-button
              v-if="!loading"
              class="btn btn-accept-color text-white"
              variant="outline-success"
              @click="onAcceptName('select')"
              :disabled="participantNameSelect === null"
            >
              Zatwierdź
            </b-button>
            <b-button
              v-else
              class="btn-accept-color"
              variant="outline-success"
              disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </b-col>

      <b-col
        lg="12"
        class="mr-1 py-2 text-center"
        v-if="participateTimeQuestion === 1"
      >
        <span class="text-danger font-weight-bold font-italic"
          >Uwaga! Podane wyżej dane pojawią się na Certyfikacie, który uzyskasz
          po udzieleniu 60% poprawnych odpowiedzi.</span
        >
      </b-col>
    </b-row>
  </b-card-text>
</template>

<script>
export default {
  name: 'CourseExamInputName',
  data() {
    return {
      participantId: 0,
      participantName: '',
      participantNameSelect: null,
      participantNameOptions: [],
      loading: false,
      participateTimeQuestion: false,
    };
  },
  created() {
    this.getSavedParticipantNames();
  },
  methods: {
    getSavedParticipantNames() {
      axios
        .post('/api/course-exam/get-saved-participant-names')
        .then(({ data }) => {
          let participantNameOptions = [{ value: null, text: 'Lista' }];
          data.forEach((row) => {
            participantNameOptions.push({
              value: row.participant_name,
              text: row.participant_name,
            });
          });
          this.participantNameOptions = participantNameOptions;
        })
        .catch((error) => {});
    },
    onAcceptName(type) {
      this.loading = true;
      axios
        .post('/api/course-exam/set-participant-name', {
          participantName:
            type === 'select'
              ? this.participantNameSelect
              : this.participantName,
        })
        .then(({ data }) => {
          this.$emit('onSetParticipantName', {
            participantId: data.participant_id,
            participantName: data.participant_name,
            examSet: data.exam_set,
            examTimeLimit: data.exam_time_limit,
            examImagesPath: data.exam_images_path,
            examPass: data.exam_pass,
          });
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    onFirstTime() {
      this.participateTimeQuestion = 1;
      window.dataLayer.push({
        event: 'btnTestPierwszyRaz',
        license_id: this.licence,
      });
    },
    onAnotherTime() {
      this.participateTimeQuestion = 2;
      window.dataLayer.push({
        event: 'btnTestPowtórnie',
        license_id: this.licence,
      });
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
::v-deep {
}
</style>
